import videojs from 'video.js'

videojs.addLanguage('pt', {
  // custom portuguese translations
  'Try again': 'Tente novamente',
  'button_try_again_in': 'Tente novamente em {1}',
  'too_many_streams_title': 'Demasiadas transmissões',
  'stream_limit_exceeded_message':
    'A sua subscrição permite {1} transmissões simultâneas. Pare a reprodução noutro dispositivo e tente novamente.',
})
